import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/OrganizationDefinitionDetailsResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/api/private/organizations/${e.orgPlaceholder}/definition/details`;
	}
	get() {
		return this.api.get(n.baseUrl);
	}
	update(e) {
		return this.api.put(n.baseUrl, e);
	}
};
//#endregion
export { n as OrganizationDefinitionDetailsResource };

//# sourceMappingURL=OrganizationDefinitionDetailsResource.js.map